export default __webpack_public_path__ + "assets/home_phone.207889ab.png";